import { PATH_NAME_LIST_VIEW_MORE } from '@/common/router.const'

export default [
  {
    path: '/view-more',
    name: PATH_NAME_LIST_VIEW_MORE,
    components: {
      listViewMore: () =>
        import(
          /* webpackChunkName: "listViewMore" */ '@/views/viewmore/ListViewMore'
        ),
    },
  },
]
